<div class="doc-panal">
  <h5 (click)="showCPDocuments()" class="viewCPStyle_1">
    <span>Documents
      <i id="view-current-issuer-documents" class="for-icon-right for-pdf"></i>
    </span>
  </h5>
</div>